import { useQuery } from 'react-query';

import Api from '../../api/api';

export type GetSuggestedCategoryDto = {
  page?: number;
  limit?: number;
  sort?: string;
  search?: string;
};

const getSuggestedCategory = async (params: GetSuggestedCategoryDto) => {
  const [response, bodyOrError] = await Api.get(`categories/suggested`, params);

  if (!response?.ok) {
    throw bodyOrError;
  }

  return bodyOrError;
};

const useGetSuggestCategory = (params: GetSuggestedCategoryDto) => {
  return useQuery({
    queryKey: ['suggestedCategories', params],
    queryFn: () => getSuggestedCategory(params),
    initialData: { total: 0, data: [], page: 0, limit: 0 },
  });
};
export default useGetSuggestCategory;
